import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions, changeDateFormat } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';
import { generateMiscReport } from "../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel";

const FinalReport = () => {
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [tableReportData, setTableReportData] = useState([]);
    const [buttonAccess, setButtonAccess] = useState({
        userLevel: "",
        roles: "",
        isVisible: false,
    });

    // const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    // const decode_token = jwtDecode(token);
    const navigate = useNavigate();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };
    const config = getAuthHeaders();


    const storedLanguage = localStorage.getItem('language');

    const getNextYear = (year) => {
        const nextYear = parseInt(year) + 1;
        return `${year}-${nextYear}`;
    };



    //get Years 
    const getAllYears = () => {
        const currentYear = new Date().getFullYear();
        const yearsArray = [];
        for (let year = currentYear; year >= 2000; year--) {
            yearsArray.push(year);
        }
        return yearsArray;
    };

    useEffect(() => {
        const level = handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level);
        setYears(getAllYears());
    }, []);

    const handleDropdownChange = (e) => {
        setYearName(e.target.value);
    };

    const handleGenerateExcel = () => {
        if (!yearName) {
            toast.error("Please select a Real Year Date", messages.COLOR_RED);
            return;
        }

        showLoading(true);
        // Prepare payload
        const payload = {
            surveyYear: yearName,
        };

        // POST request to API
        axios
            .post(`${API_URL}api/price/prifinal`, payload, config)
            .then((response) => {
                const finalReport = response.data.data[0].GroupCodes;

                if (!finalReport || finalReport.length === 0) {
                    toast.info("Data not found");
                    showLoading(false);
                    return;
                }

                let excelFileName = `FinalReport${yearName}_${parseInt(yearName)+1}`;
                const excelObjectData = {
                    fileName: excelFileName,
                    reportType: excelFileName,
                    fileType: 'xlsx',
                    sheetName: "Final_Report",
                    firstRowMergeCells: "A1:H1",
                    firstRowExportDate: changeDateFormat(new Date()),
                    firstRowCellNumber: 5,
                    secondRowMergeCells: "A2:H2",
                    secondRowText: `Price Wages Indices System (Final Report)`,
                    headerHindiColumns: [
                        'लेखा', 'शीर्षक ', 'Price 1', 'price 2', 'Price 3', 'Price 4', 'Price 5', 'Price 6'
                    ],
                };

                const transformedData = finalReport.map((item, index) => [
                    index + 1,
                    item.field1,
                    item.bigdecimal1,
                    item.bigdecimal2,
                    item.bigdecimal3,
                    item.bigdecimal4,
                    item.bigdecimal5,
                    item.bigdecimal6
                ]);
                excelObjectData.excelRowData = transformedData;

                generateMiscReport(excelObjectData);

                showLoading(false);
            })
            .catch((error) => {
                console.error('API Error:', error);
                showLoading(false);
            });
    };

    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.FINAL_REPORT : priceTitle.en.FINAL_REPORT }} />

                            </h4>
                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                        Select Real Year Date
                                    </label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={handleDropdownChange}
                                        value={yearName}
                                    >
                                        <option value="" disabled>
                                            Select Year
                                        </option>
                                        {years &&
                                            years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                    {getNextYear(ele)}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default FinalReport